import { render, staticRenderFns } from "./NotificationTemplateSetup.vue?vue&type=template&id=201604e6&scoped=true"
import script from "./NotificationTemplateSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplateSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTemplateSetup.vue?vue&type=style&index=0&id=201604e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201604e6",
  null
  
)

export default component.exports